import { useRouter } from "next/router";
import { isLocalWorklistPathname } from "../utils/zoneRoutes";
function useCheckBulkActions() {
  var _useRouter = useRouter(),
    pathname = _useRouter.pathname;
  if (isLocalWorklistPathname(pathname)) {
    return true;
  }
  return false;
}
export default useCheckBulkActions;